export default __webpack_public_path__ + "static/media/entrata-logo.720393f0.svg";